/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./integrations.vue?vue&type=template&id=8060ed94&scoped=true"
import script from "./integrations.vue?vue&type=script&lang=js"
export * from "./integrations.vue?vue&type=script&lang=js"
import style0 from "./integrations.vue?vue&type=style&index=0&id=8060ed94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8060ed94",
  null
  
)

export default component.exports